module.exports = __webpack_public_path__ + "static/media/Fontfabric - MullerUltraLightItalic.e1ec95d5.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/Fontfabric - MullerUltraLightItalic.otf
// module id = 1075
// module chunks = 0